export default __webpack_public_path__ + "static/media/027-yatch.6dbe58a8.png";